/**
 * Logs all actions and states after they are dispatched.
 */
export const logger = store => next => action => {
    let result = next(action);
    return result
};